export default function shouldDisableMarkersPanel(parm) {
  return !parm.arena_in_progress || !parm.arena_rolled // || parm.arena_extra_ready
}
